/** @jsx jsx */

import React, { Fragment as _, useState, useContext } from 'react';
import { css, jsx } from '@emotion/core';
import { interactionContext } from './interactionContext';
import { FiveStarRatingContext } from './FiveStarRating_v2';

const FiveStarList = props => {
  const { children } = props;

  const { starColor } = useContext(interactionContext).props;
  const { rating, onUpdateRating } = useContext(FiveStarRatingContext);

  const [hoverIndex, setHoverIndex] = useState();

  return (
    <div
      css={css`
        display: flex;
        flex-direction: column;
        align-items: center;
        width: 100%;
        padding: 50px;
      `}
    >
      <div
        css={css`
          display: flex;
          margin: 0 0 20px 0;
        `}
      >
        {children.map((child, index) =>
          React.cloneElement(child, {
            key: `child_${index}`,
            index,
            color: starColor,
            onHover(index) {
              setHoverIndex(index);
            },
            isHovered: hoverIndex >= index,
            rating,
            selected: rating !== null && index <= rating,
            onClick() {
              onUpdateRating(index);
            },
          })
        )}
      </div>
    </div>
  );
};

export default FiveStarList;
